'use strict';

var React = require('react');
var appTypes = require('../../types/appTypes');
var assetsHelper = require('../../helper/assetsHelper');
var util = require('../../helper/util');
var styleHelper = require('../../helper/styleHelper');

/**
 * 菜单组件
 */

var ToggleType = {toggleNone: 0, toggleCircle: 1, toggleMark: 2, toggleDisable: 3};

var MenuItem = React.createClass({
  propTypes: {
    selected: React.PropTypes.bool.isRequired,
    onClickEvent: React.PropTypes.func.isRequired,
    data: React.PropTypes.object.isRequired,
    height: React.PropTypes.number.isRequired
  },

  render: function () {

    var backgroundStyle;
    var toggleStyle;
    var toggleClass;
    var itemStyle;
    var showToggle;
    var toggleBoundary;

    backgroundStyle = {
      width:'100%',
      height: this.props.data.separator ? 1 : this.props.height,
      lineHeight: this.props.height + 'px',
      position: 'absolute',
      right: this.props.data.separator ? 2 : 0,
      color: this.props.data.toggle === ToggleType.toggleDisable ? appTypes.Color.MODEL_DISABLE : undefined,
      left: this.props.data.separator ? 2 : 0,
      top: this.props.top,
      backgroundColor: this.props.data.separator ? '#000' : (this.props.selected && this.props.data.toggle !== ToggleType.toggleDisable ? this.props.selectedColor : undefined),
      textDecoration:'inherit'
    };

    showToggle = (this.props.data.toggle === ToggleType.toggleCircle) || (this.props.data.toggle === ToggleType.toggleMark);


    if (this.props.data.toggle === ToggleType.toggleCircle) {
      toggleStyle = {
        top: (this.props.itemHeight - 10) / 2 + 'px'
      };
      toggleClass = 'toggle-radio';
    } else if (this.props.data.toggle === ToggleType.toggleMark) {
      toggleStyle = {
        top: (this.props.itemHeight - 8) / 2 - 2 + 'px'
      };
      toggleClass = 'toggle-check'
    }

    return (<div style={backgroundStyle} onClick={this.props.onClickEvent}>
      <div className="item">
        {
          showToggle &&
          <div className="toggle">
            <div className={toggleClass} style={toggleStyle}></div>
          </div>
        }
        {
          !this.props.data.separator &&
          <label className="menu-text">{util.Text.convertSpaceToNbsp(this.props.data.content)}</label>
        }
        {
          this.props.data.shortcut &&
          <label className="menu-short">{this.props.data.shortcut}</label>
        }
        {
          this.props.data.isNotLeaf &&
          <img src={assetsHelper.getComponentAsset('commons/separator')}/>
        }
      </div>
    </div>)
  }
});

var Menu = React.createClass({

  _parseTextItem: function (itemText) {
    var resultItem;
    var tempText = itemText.trim();
    itemText = itemText.trim();

    resultItem = {
      toggle: ToggleType.toggleNone,
      content: '',
      shortcut: '',
      separator: (tempText === '') || (tempText.replace(/\-/g, '') === '') || (tempText.replace(/=/g, '') === '')
    };


    if (resultItem.separator)
      return resultItem;

    if (itemText.charAt(0) === '-' && itemText.charAt(itemText.length - 1) === '-') {
      itemText = itemText.substring(1, itemText.length - 1);
      resultItem.toggle = ToggleType.toggleDisable;
    }

    if (itemText.length >= 2 && itemText.charAt(1) === ' ') {
      if (itemText.charAt(0) === 'o') {
        resultItem.toggle = ToggleType.toggleCircle;
        itemText = itemText.substring(2, itemText.length);
      } else if (itemText.charAt(0) === 'x') {
        resultItem.toggle = ToggleType.toggleMark;
        itemText = itemText.substring(2, itemText.length);
      }
    }

    if (itemText.charAt(itemText.length - 1) === '>') {
      resultItem.content = itemText.substring(0, itemText.length - 1).trim();
      resultItem.isNotLeaf = true;
    } else {
      if (itemText.indexOf(',') !== -1) {
        resultItem.content = itemText.substring(0, itemText.indexOf(','));
        resultItem.shortcut = itemText.substring(itemText.indexOf(',') + 1, itemText.length);
      } else {
        resultItem.content = itemText;
      }
    }


    return resultItem;
  },

  _parseText: function () {

    var textArray = util.Text.delimitToParagraphs(styleHelper.getText(this.props));
    var resultArray = [];

    textArray.forEach(function (text) {
      text = text.trim();
      resultArray.push(this._parseTextItem(text));
    }.bind(this));

    return resultArray;
  },

  getInitialState: function () {
    return {
      selectedIndex: this.props.selectedIndex
    };
  },

  render: function () {
    var itemArray = this._parseText();
    var borderStyle = {
      borderColor: '#000'
    };
    var top = 0;
    styleHelper.StyleUtil(this.props,borderStyle).background().text();
    return (<div className="border" style={borderStyle}>
      {
        itemArray.map(function (itemData, index) {
          var h = this.props.itemHeight;

          if(itemData.separator){
            h = 1;
          }
          var item = <MenuItem {...this.props}
            selected={this.state.selectedIndex == index}
            data={itemData}
            top={top}
            height={parseInt(this.props.itemHeight, 10)}
            onClickEvent={this._onClick.bind(this,index)}
          />;
          top += h;
          return item;
        }.bind(this))
      }
    </div>);
  },

  _onClick(index) {
    this.setState({selectedIndex: index});
  }
});

module.exports = Menu;



/** WEBPACK FOOTER **
 ** ./src/views/Components/Menu.jsx
 **/